import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import { TemplateField } from '../templateField';
import { ruleRowNameSize, ruleRowFieldsSize, row } from '../utils';
import RuleRowHeader from '../ruleRowHeader';

const RuleFields = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container item xs={row}>
      <Grid item {...ruleRowNameSize} className={classes.EventTypeNameField}>
        <RuleRowHeader
          headerText={t(`eventType.${props.rule.eventType}`)}
          eventType={props.rule.eventType}
          index={props.rule.index}
        />
      </Grid>
      <Grid
        container
        item
        justifyContent="flex-start"
        alignItems="stretch"
        {...ruleRowFieldsSize}
        className={classes.RuleFields}
      >
        <TemplateField
          selectOptions={props.selectOptions}
          rule={props.rule}
          fieldName="series"
        />
        <TemplateField
          selectOptions={props.selectOptions}
          rule={props.rule}
          fieldName="company"
        />
        <TemplateField
          selectOptions={props.selectOptions}
          rule={props.rule}
          fieldName="voucherText"
        />
        <TemplateField
          selectOptions={props.selectOptions}
          rule={props.rule}
          fieldName="transactionText"
        />
      </Grid>
    </Grid>
  );
};

RuleFields.propTypes = {
  selectOptions: PropTypes.object,
  hover: PropTypes.bool,
  rule: PropTypes.object,
};

export default React.memo(RuleFields);
